module.exports = __webpack_public_path__ + "media/games-17.c616a4da.mp4";